import React, {
  useEffect, useState, useRef, useCallback
} from 'react';
import { EnumPageStatus } from '@/src/pages/customer_service/lib/constant';
import './index.css';

export default function Index(props) {
  const { pageStatus, pageStatusData, onReloadingClick } = props;

  return (
    <view className="page-status-container">
      {pageStatus === EnumPageStatus.Empty && (
        <view className="page-status-top-distance">
          <image autoRTL className="page-status-progress-img" src="assets://newcustomerservice/page_empty.png" />
          {pageStatusData.emptyTitle && <text className="page-status-title-text">{pageStatusData.emptyTitle}</text>}
          {pageStatusData.emptyTip && <text className="page-status-tip-text">{pageStatusData.emptyTip}</text>}
        </view>
      )}

      {pageStatus === EnumPageStatus.Fail && (
        <view className="page-status-top-distance" onClick={() => onReloadingClick()}>
          <image autoRTL className="page-status-err-img" src="assets://newcustomerservice/net_error.png" />
          {pageStatusData.failTitle && <text className="page-status-title-text">{pageStatusData.failTitle}</text>}
          {pageStatusData.failTip && <text className="page-status-tip-text">{pageStatusData.failTip}</text>}
        </view>
      )}
    </view>
  );
}
